module.exports = __webpack_public_path__ + "static/4-mozilla-geo-api-ccc8326c63c04dddb291c4d6bc13cfdf.png";